import * as React from "react"
import {Typography} from '@mui/material'
import {formatPercentage} from "@ui-seeker/utils"


export default function totalDiffColumn() {
	return {
		name: 'totalDiff',
		label: 'Total Active (%)',
		options: {
			filter: false,
			customBodyRowRenderLite: (value) => <Typography sx={{ fontSize: '0.875rem', textAlign: 'center' }}>
				{ !!value ? formatPercentage(value) : '-' }
			</Typography>
		}
	}
}